import { Record } from "immutable";

import { ApprovalFlowEntityModel } from "./ApprovalFlowEntityModel";

const NO_IDENTIFIER_APPROVAL_FLOW_NOTIFIED_ENTITY_TYPE = [
  "DirectManager" as const,
  "IntegrationMaintainer" as const,
  "IntegrationOwner" as const,
  "ResourceMaintainer" as const,
  "ResourceOwner" as const,
  "TeamMember" as const,
];

type TApprovalFlowNotifiedEntityType =
  | "DirectoryGroup"
  | "HR"
  | "OnCallIntegrationSchedule"
  | "SlackChannel"
  | "User"
  | "Webhook"
  | TNoIdentifierApprovalFlowNotifiedEntityType;

type TNoIdentifierApprovalFlowNotifiedEntityType = (typeof NO_IDENTIFIER_APPROVAL_FLOW_NOTIFIED_ENTITY_TYPE)[number];

const isNoIdentifierApprovalFlowNotifiedEntityType = (
  entityType: TApprovalFlowNotifiedEntityType,
): entityType is TNoIdentifierApprovalFlowNotifiedEntityType =>
  NO_IDENTIFIER_APPROVAL_FLOW_NOTIFIED_ENTITY_TYPE.includes(entityType as TNoIdentifierApprovalFlowNotifiedEntityType);

const defaults = {
  displayName: null as null | string,
  identifier: null as null | string,
  type: "" as TApprovalFlowNotifiedEntityType,
};

export interface IApprovalFlowNotifiedEntitySchema {
  displayName: null | string;
  identifier: null | string;
  type: TApprovalFlowNotifiedEntityType;
}

export class ApprovalFlowNotifiedEntityModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown) {
    const { displayName, identifier, type } = data as IApprovalFlowNotifiedEntitySchema;

    return new ApprovalFlowNotifiedEntityModel({
      displayName,
      identifier: isNoIdentifierApprovalFlowNotifiedEntityType(type) ? type : identifier,
      type,
    });
  }

  toApprovalEntity(): ApprovalFlowEntityModel {
    const { displayName, identifier, type } = this;
    return new ApprovalFlowEntityModel({ displayName, identifier, type });
  }

  toServerData(): IApprovalFlowNotifiedEntitySchema {
    const { displayName, identifier, type } = this;
    return {
      displayName,
      identifier: isNoIdentifierApprovalFlowNotifiedEntityType(type) ? null : identifier,
      type,
    };
  }
}
